import * as NS from './namespace';

const getters: NS.IAppGetters = {
    getAppName(state: NS.IAppState): string {
        return state.appName;
    },
    getShortAppName(state: NS.IAppState): string {
        return state.shortAppName;
    },
    getCopyright(state: NS.IAppState): string {
        return state.copyright;
    },
    getCopyrightLink(state: NS.IAppState): string {
        return state.copyrightLink;
    },
    getDevLink(state: NS.IAppState): string {
        return state.devLink;
    },
};

/**
 * Реализация доступа к общим настройкам сайта
 */
export default getters;